window.addEventListener('load', () => {
  // Data-review pages omit the banner. See marketing.gohtml.
  const $headerStatus = document.querySelector<HTMLDivElement>(
    '.js-header__system-status',
  );
  if (!$headerStatus) {
    return;
  }

  // Wait 1 second before the first poll, so a Playwright test can mock the
  // status API after the page loads.
  setTimeout(() => updateSystemStatus($headerStatus), 1000);

  setInterval(() => {
    if (!document.hidden) {
      updateSystemStatus($headerStatus);
    }
  }, 30 * 1000);
});

const setSystemStatus = (
  $headerStatus: HTMLDivElement,
  message: string | undefined,
) => {
  const $headerStatusMessage = <HTMLDivElement>(
    document.querySelector('.js-header__status-message')
  );
  const show = message !== undefined;

  document.querySelectorAll('.status-icon__warning').forEach(($icon) => {
    $icon.classList.toggle('show-status-icon', show);
  });
  $headerStatus.classList.toggle('show-header-system-status', show);
  $headerStatusMessage.innerText = message ?? '';
};

// Status.io is a third party, so a failed request keeps the current banner
// and the next poll tries again. setSystemStatus stays outside the try, so a
// bug in it still throws.
const updateSystemStatus = async ($headerStatus: HTMLDivElement) => {
  let message: string | undefined;
  try {
    message = await getSystemStatusMessage();
  } catch (err) {
    console.error('Could not update the system status:', err);
    return;
  }
  setSystemStatus($headerStatus, message);
};

// getSystemStatusMessage returns undefined when all systems are operational.
const getSystemStatusMessage = async (): Promise<string | undefined> => {
  // Do not use status.maxmind.com. CloudFront serves it and can cache a stale
  // status for up to 30 minutes. Status.io supports this host for its Public
  // Status API. The host must match statusAPIOrigin in go/pkg/website/csp.go.
  const response = await fetch(
    'https://0353655954175547.hostedstatus.com/1.0/status/53fcfbb2ac0c957972000235',
  );
  if (!response.ok) {
    throw new Error(`Status API responded with HTTP ${response.status}`);
  }
  const json = await response.json();
  if (json.result === undefined) {
    throw new Error(
      `Status API responded without a result: ${JSON.stringify(json)}`,
    );
  }

  const customIncident = json.result.incidents;
  const customMaintenance = json.result.maintenance.active;
  const systemStatusCode = json.result.status_overall.status_code;

  if (customIncident.length != 0) {
    return `${json.result.status_overall.status}: ${customIncident[0].name}`;
  }
  if (customMaintenance.length != 0) {
    return `${json.result.status_overall.status}: ${customMaintenance[0].name}`;
  }

  // https://kb.status.io/developers/status-codes/
  switch (systemStatusCode) {
    case 100:
      return undefined;
    case 200:
      return (
        'Planned Maintenance: We are currently undergoing some ' +
        'scheduled maintenance.'
      );
    case 300:
      return (
        'Degraded Performance: We are currently experiencing ' +
        'degraded performance in some of our web services.'
      );
    case 400:
      return (
        'Partial Service Disruption: Some of our web services ' +
        'are temporarily unavailable.'
      );
    case 500:
      return 'Service Disruption: Our web services are temporarily unavailable.';
    case 600:
      return (
        'Security Event: We are currently mitigating issues ' +
        'relating to some of our web services.'
      );
    default:
      throw new Error(`Unknown status code: ${systemStatusCode}`);
  }
};
